import React, { useState } from "react";
import { useCustomTranslation } from "../../../../helpers/translateHelpers";
import HomeInterventionsTable from "./HomeInterventionsTable";
import { Title } from "../../../../components";
import HomeGoToFooter from "../HomeGoToFooter";
import { useNavigate } from "../../../../helpers/navigationHelpers";
import { InterventionTableQuery } from "../../../interventions/models";
import { useGetInterventionsQuery } from "../../../interventions/queries";
import { defaultHomeInterventionsTableQuery } from "./helper";

const HomeCompletedInterventionsContent: React.FC = (): React.ReactElement => {
  const { tCommon } = useCustomTranslation();
  const navigate = useNavigate();

  const [queryParams, setQueryParams] = useState<InterventionTableQuery>({
    ...defaultHomeInterventionsTableQuery,
    daysInPast: 365,
    state: "Completed,Cancelled",
  });

  const query = useGetInterventionsQuery(queryParams);

  return (
    <div className="my-4">
      <Title title={tCommon("home_completed_interventions")} />
      <p className="mb-4">
        {tCommon("home_completed_interventions_description")}
      </p>
      <HomeInterventionsTable
        data={query.data?.data ?? []}
        isLoading={query.isLoading}
        queryParams={queryParams}
        setQueryParams={setQueryParams}
        total={query.data?.total ?? 0}
      />
      <HomeGoToFooter
        title={tCommon("home_other_interventions")}
        description={tCommon("home_other_interventions_description")}
        buttonLabel={tCommon("home_other_interventions_button")}
        onClick={() => navigate.goTo("interventions")}
      />
    </div>
  );
};

export default HomeCompletedInterventionsContent;
